import { render, staticRenderFns } from "./DragAndDropBox.vue?vue&type=template&id=828f4b96&scoped=true&"
import script from "./DragAndDropBox.vue?vue&type=script&lang=ts&"
export * from "./DragAndDropBox.vue?vue&type=script&lang=ts&"
import style0 from "./DragAndDropBox.vue?vue&type=style&index=0&id=828f4b96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828f4b96",
  null
  
)

export default component.exports